import { FieldVisibilityCondition } from './field-visibility-condition';
import { GroupVisibilityCondition } from './group-visibility-condition';
import { HierarchyVisibilityCondition } from './hierarchy-visibility-condition';
import { QuestionnaireVisibilityCondition } from './questionnaire-visibility-condition';
import { RecordLinkVisibilityCondition } from './record-link-visibility-condition';
import { RiskRatingVisibilityCondition } from './risk-rating-visibility-condition';
import type { VisibilityConditionBase } from './visibility-condition-base';
import type {
  VisibilityCondition,
  VisibilityConditionType,
} from './visibility-condition.interfaces';

export class VisibilityConditionFactory {
  public static getVisibilityCondition(
    visibilityType: VisibilityConditionType,
    fieldCondition: VisibilityCondition,
  ): VisibilityConditionBase | undefined {
    switch (visibilityType) {
      case 'FIELD':
        return new FieldVisibilityCondition(fieldCondition);
      case 'GROUP':
        return new GroupVisibilityCondition(fieldCondition);
      case 'HIERARCHY':
        return new HierarchyVisibilityCondition(fieldCondition);
      case 'QUESTIONNAIRE':
        return new QuestionnaireVisibilityCondition(fieldCondition);
      case 'RISKRATING':
        return new RiskRatingVisibilityCondition(fieldCondition);
      case 'RECORDLINK':
        return new RecordLinkVisibilityCondition(fieldCondition);
    }
  }
}
